import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';
import expand from '../../images/common/expand.svg';
import ColorSF2 from '../../styles/common/ColorSF2';
import contract from '../../images/common/contract.svg';
import list from '../../images/common/view_list.svg';
import grid from '../../images/common/view_module.svg';
import {
  PAGE_PATH,
  PAGE_PATH_PARAM_OPERATORID,
  TIMELINE_SCREEN_MODE,
} from '../../lib/constants';
import ChevronRight from '../Icons/ChevronRight';
import UserIcon from '../Parts/UserIcon';
import {
  Wrapper,
  TitleWrapper,
  Title,
  Storage,
  ButtonsWrapper,
  Button,
  TrashButton,
  ButtonImage,
  LinkButtonImage,
  PrivateButtonWrapper,
  OperatorName,
} from './styles/TimeLineTitleStyles';
import { isGuest } from '../../lib/tools';

const StyledLink = styled(RouterLink)`
  color: ${ColorSF2.black};
  text-decoration: none;
  cursor: pointer;
  padding-left: 10px;
`;

const createDisplayStorageLicense = currentCompanyInfo => {
  if (Object.keys(currentCompanyInfo).length <= 0) {
    return null;
  }
  const usedMibNumber =
    (currentCompanyInfo.storageLicense.usedMibNumber > 0 &&
      Math.fround(
        currentCompanyInfo.storageLicense.usedMibNumber / 1024,
      ).toFixed(1)) ||
    '0.0';
  const usageState = `${usedMibNumber}/${currentCompanyInfo.storageLicense.contractNumber}`;
  return usageState;
};

const TimeLineTitle = ({
  userInfo,
  fullScreen,
  timeLineScreenMode,
  onSwitchTimeLineScreenMode,
  currentCompanyInfo,
  provider,
}) => {
  const isGuestUser = isGuest(userInfo.role);

  const linkTo = () => {
    if (isGuestUser) {
      const url = PAGE_PATH.DS_TIMELINETILE_WITH_OPERATOR_ID.replace(
        PAGE_PATH_PARAM_OPERATORID,
        userInfo.operatorId,
      );
      return url;
    }
    if (fullScreen) {
      return PAGE_PATH.DS_ROOT;
    }
    return PAGE_PATH.DS_TIMELINE;
  };
  const linkToImage = (fullScreen && contract) || expand;
  const modeImage =
    timeLineScreenMode === TIMELINE_SCREEN_MODE.list ? grid : list;
  const storage = createDisplayStorageLicense(currentCompanyInfo);
  const isCansuke = provider && provider.isCansuke;
  return (
    <Wrapper className="timeLineTitle">
      <TitleWrapper>
        <Title>
          {fullScreen ? (
            <FormattedMessage id="timeLine.title" />
          ) : (
            <FormattedMessage id="timeLine.dashboard.title" />
          )}
          {storage && (
            <Storage>
              <FormattedMessage id="timeLine.storage" values={{ storage }} />
            </Storage>
          )}
        </Title>
      </TitleWrapper>
      <ButtonsWrapper>
        {fullScreen && !isCansuke && (
          <StyledLink to="/trash">
            <TrashButton
              className="button"
              id="clickTrashButton"
              role="presentation"
            >
              <FormattedMessage id="timeline.trash" />
            </TrashButton>
          </StyledLink>
        )}
        {fullScreen && (
          <Button
            className="button"
            id="clickSwitchButton"
            role="presentation"
            onClick={() => onSwitchTimeLineScreenMode()}
          >
            <ButtonImage src={modeImage} alt="timelineSwitchButton" />
          </Button>
        )}
        {!isCansuke && (
          <StyledLink to={linkTo}>
            <Button
              className="button"
              id="clickCloseButton"
              role="presentation"
            >
              {(isGuestUser && (
                <PrivateButtonWrapper>
                  <UserIcon url={userInfo.iconUrl} />
                  <OperatorName>{userInfo.name}</OperatorName>
                  <ChevronRight
                    color={ColorSF2.navyBlue}
                    width="25px"
                    height="25px"
                  />
                </PrivateButtonWrapper>
              )) || (
                <LinkButtonImage
                  src={linkToImage}
                  alt="timelineOpenCloseButton"
                />
              )}
            </Button>
          </StyledLink>
        )}
      </ButtonsWrapper>
    </Wrapper>
  );
};

TimeLineTitle.propTypes = {
  userInfo: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  timeLineScreenMode: PropTypes.number.isRequired,
  onSwitchTimeLineScreenMode: PropTypes.func.isRequired,
  currentCompanyInfo: PropTypes.object.isRequired,
  provider: PropTypes.object.isRequired,
};

export default TimeLineTitle;
